export default "__VITE_ASSET__B7b4cPdB__"